__webpack_require__.p = "/vadmin/";